import BaseContentDetailsDetailsSubPageView from "scripts/views/baseContentDetailsDetailsSubPageView";
import templateContentDetailsBookPageDetailsSubPage from "templates/contentDetailsBookPageDetailsSubPage.hbs";
// import templateCategoryLink from "templates/categoryLink.hbs";
// import ContentDetailsPageAlsoFoundInSubPageView from "./contentDetailsPageAlsoFoundInSubPageView";

class ContentDetailsBookPageDetailsSubPageView extends BaseContentDetailsDetailsSubPageView {
  // constructor(options) {
  //   super(options);

  //   // this.alsoFoundInView = this.addSubView(
  //   //     new ContentDetailsPageAlsoFoundInSubPageView({
  //   //       model: new Backbone.Model({
  //   //         mediaId: this.model.get("id"),
  //   //       }),
  //   //     })
  //   // );
  // }

  get template() {
    return templateContentDetailsBookPageDetailsSubPage;
  }

  render() {
    super.render();

    // if (this.model.has("bisacCategories")) {
    //   this.addCategories(this.model.get("bisacCategories"));
    // }
    //
    // if (this.alsoFoundInView) {
    //   this.alsoFoundInView
    //       .attachTo($("#bb-content-details-also-found-in-region"))
    //       .fetch()
    //       .then(() => this.alsoFoundInView.render());
    // }

    return this;
  }

  // get categoryTemplate() {
  //   return templateCategoryLink;
  // }
  //
  // addCategories(categories) {
  //   const $categories = $(
  //     "#bb-content-details-book-page-details-sub-page-category-region",
  //   );
  //
  //   const commaSeparatedCategoryLinks = categories
  //     .map(category => {
  //       return this.categoryTemplate(category);
  //     })
  //     .join(",&nbsp;");
  //
  //   $categories.html(commaSeparatedCategoryLinks);
  // }
}

export default ContentDetailsBookPageDetailsSubPageView;
